import type {ComponentType} from 'react'
import {AuthRedirectWrapper} from './auth-redirect'

type Props = {
  component: ComponentType<object>
}

export function AuthRedirectRoute(props: Props) {
  const {component: Component} = props

  return (
    <AuthRedirectWrapper>
      <Component />
    </AuthRedirectWrapper>
  )
}
